import { gql } from '@apollo/client';
import { RELATIONSHIP_FIELDS } from '../queries/OrganisationRelationships';

export const CREATE_ORGANISATION_RELATIONSHIP = gql`
  mutation CreateOrganisationRelationship($input: CreateOrganisationRelationshipInput!) {
    createOrganisationRelationship(input: $input) {
      ${RELATIONSHIP_FIELDS}
    }
  }
`;

export const UPDATE_ORGANISATION_RELATIONSHIP_ROLES = gql`
  mutation UpdateOrganisationRelationshipRoles($input: UpdateOrganisationRelationshipRolesInput!) {
    updateOrganisationRelationshipRoles(input: $input) {
      ${RELATIONSHIP_FIELDS}
    }
  }
`;

export const END_ORGANISATION_RELATIONSHIP = gql`
  mutation EndOrganisationRelationship($input: EndOrganisationRelationshipInput!) {
    endOrganisationRelationship(input: $input) {
      ${RELATIONSHIP_FIELDS}
    }
  }
`;
